<template>
  <a-modal
    :title="$t('user.changePassword')"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    width="500px"
  >
    <a-form :form="form">
      <a-form-item 
        :label="$t('oldPassword')" 
        :label-col="{ span: 5 }" 
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          v-decorator="[
            'oldPassword',
            {
              validateTrigger: 'blur',
              rules: [{ required: true, message: $t('enter') + ' ' + $t('oldPassword') }]
            }
          ]"
          type="password"
        />
      </a-form-item>

      <a-form-item 
        :label="$t('newPassword')" 
        :label-col="{ span: 5 }" 
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          v-decorator="[
            'password',
            {
              validateTrigger: 'blur',
              rules: [{ required: true, message: $t('enter') + ' ' + $t('newPassword') }]
            }
          ]"
          type="password"
        />
      </a-form-item>

      <a-form-item 
        :label="$t('confirmPassword')" 
        :label-col="{ span: 5 }" 
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          v-decorator="[
            'confirmPassword',
            {
              validateTrigger: 'blur',
              rules: [
                { required: true, message: $t('enter') + ' ' + $t('confirmPassword') },
                { validator: validateConfirmPassword }
              ]
            }
          ]"
          type="password"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import CONST_REQUEST from '@/constants/request'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModifyPasswordModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapGetters('language', ['languageStorage'])
  },
  methods: {
    ...mapActions(['modifyPassword', 'LogoutV1']),
    open() {
      this.visible = true
      this.form.resetFields()
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          this.modifyPassword(values).then(res => {
            if (res.code === CONST_REQUEST.CODE_SUCCESS) {
              this.$message.success(this.$t('success'))
              this.visible = false
              this.$emit('success')
              // Logout after password change
              this.LogoutV1({}).then(() => {
                this.$router.push('/user/login')
              })
            } else {
              this.$message.error(res.msg || this.$t('user.passwordModifyFailed'))
            }
          }).catch(e => {
            this.$message.error(e.message || this.$t('user.passwordModifyFailed'))
            this.visible = false
          }).finally(() => {
            this.confirmLoading = false
            this.handleCancel()
          })
        }
      })
    },
    validateConfirmPassword(rule, value, callback) {
      const password = this.form.getFieldValue('password')
      if (value && value !== password) {
        callback('Two passwords that you enter is inconsistent!')
      } else {
        callback()
      }
    }
  }
}
</script>
